'use strict';

import { environment } from '@environments/environment';
import { Airport } from '@ibe/models';
import { FlightStopover } from '@ibe.models/flight.model.lib';
import { INDRADateService } from '@ibe.services/date.indra.service';

export type BookingStepCost = {
	currency: {
		value: number,
		unit: string,
		name: string,
	};
	points: number;
};

export class BookingStep {
	_date: any;
	_departure: Airport;
	_arrival: Airport;
	_cost: BookingStepCost = null;
	isStarAlliance?: boolean;

	stopover: FlightStopover;

	_selecting: 'date' | 'flight' = 'date';
	flight_selected = false;
	date_selected = false;

	constructor(departure: Airport, arrival: Airport, date?: Date, stopover?: FlightStopover) {
		this._departure = departure;
		this._arrival = arrival;
		if (date) {
			this._date = this.INDRA_toISOString(date);
		} else {
			this._date = null;
		}

		if (stopover) {
			this.stopover = stopover;
		}
	}

	get departure() {
		return this._departure;
	}

	set departure(newDeparture: Airport) {
		this._departure = newDeparture;
	}

	get arrival() {
		return this._arrival;
	}

	set arrival(newArrival: Airport) {
		this._arrival = newArrival;
	}

	get date() {
		if (this._date) {
			return this._date instanceof Date ? this._date : new Date(this._date);
		} else {
			return null;
		}
	}

	showDate() {
		if (this.date) {
			// return this._date.toLocaleDateString(environment.locale, {
			// 	month: 'long',
			// 	day: 'numeric'
			// });
			return this.date.toLocaleDateString(environment.locale, {
				weekday: 'short',
				day: 'numeric',
				month: 'short',
				year: 'numeric'
			});
		} else {
			return '--/--/----';
		}
	}

	get time() {
		if (this.flight_selected) {
			return this.date.toLocaleTimeString(environment.locale, {
				hour: 'numeric',
				minute: 'numeric'
			});
		} else {
			return '--:--';
		}
	}

	set date(value: Date) {
		if (value instanceof Date) {
			const date = new Date(value);
			this._date = this.INDRA_toISOString(date);
		} else {
			this._date = null;
		}
	}

	get done() {
		return !!this._date;
	}

	get codeArrival() {
		return this._arrival ? this._arrival.code : null;
	}
	get codeDeparture() {
		return this._departure ? this._departure.code : null;
	}
	get nameArrival() {
		return this._arrival && this._arrival.location ? this._arrival.location.city : null;
	}
	get nameDeparture() {
		return this._departure && this._departure.location ? this._departure.location.city : null;
	}

	toString() {
		return (
			(this._departure ? this._departure.code + ' -> ': 'Blank Departure -> ') +
			(this._arrival ? this._arrival.code: 'Blank Arrival') +
			' on ' +
			this.date +
			' at ' +
			this.time
		);
	}

	get cost() {
		return this._cost;
	}

	set cost(newCost) {
		if (newCost) this._cost = newCost;
	}

	INDRA_toISOString(date: Date) {
		var tzo = -date.getTimezoneOffset(),
		dif = tzo >= 0 ? '+' : '-',
		pad = function(num) {
			return (num < 10 ? '0' : '') + num;
		};

		return date.getFullYear() +
			'-' + pad(date.getMonth() + 1) +
			'-' + pad(date.getDate()) +
			'T' + pad(date.getHours()) +
			':' + pad(date.getMinutes()) +
			':' + pad(date.getSeconds()) +
			dif + pad(Math.floor(Math.abs(tzo) / 60)) +
			':' + pad(Math.abs(tzo) % 60);
	}
}
